import { useParams } from 'react-router-dom'

export const useContractUuid = (): string => {
  const { contractId } = useParams<{ contractId: string }>()
  return contractId ?? ''
}
